import Grid from '@mui/material/Grid';
import { styled } from '@mui/material/styles';

export const StContainer = styled(Grid)(({ theme }) => ({
  flexDirection: 'row',
  flexWrap: 'nowrap',
  alignItems: 'flex-start',
  paddingTop: '1rem',
  gap: '10px',

  [theme.breakpoints.down('sm')]: {
    flexDirection: 'row',
    gap: '6px',
    paddingTop: '0.75rem',
  },

  [theme.breakpoints.between('sm', 'md')]: {
    flexDirection: 'row',
    gap: '8px',
    paddingTop: '0.875rem',
  },
}));
